import { render } from "./apps.vue?vue&type=template&id=cc4ce094"
const script = {}

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__